import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";

import { ModalService } from "pf_styleguide";

import { CheckoutPopupOpenInterface } from "./checkout.popup.open.interface";

@Component({
    selector: "pf-checkout-popup",
    templateUrl: "./checkout-popup.component.html",
})
export class CheckoutPopupComponent implements OnInit {
    @Input() open: EventEmitter<CheckoutPopupOpenInterface> =
        new EventEmitter();
    @ViewChild("checkoutPopupContent") popupContent: ElementRef<any>;

    checkoutData: CheckoutPopupOpenInterface;
    constructor(private modalService: ModalService, private router: Router) {}

    ngOnInit(): void {
        this.open.subscribe((data: CheckoutPopupOpenInterface) => {
            this.checkoutData = data;
            this.modalService.open(this.popupContent, {
                windowClass: "sg-modal-secondary",
            });
        });
    }

    checkout(): void {
        this.modalService.close();
        // // it has to be by url due to slot url being pulled from venue page (not pitch page)
        this.router.navigateByUrl(
            // tslint:disable-next-line:prefer-template
            this.checkoutData.pitchData.data.links.weblink.replace(
                /https?:\/\/[^\/]+/i,
                ""
            ) +
                "/checkout/" +
                this.checkoutData.slot.id
        );
    }
}
